import { Theme, useMediaQuery } from '@mui/material';

export const useBreakpoints = () => {
  const isDownMdLayout = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
  const isDownSmLayout = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));

  return { isDownMdLayout, isDownSmLayout };
};
